import React, { Component } from 'react';
import * as Scale from './scales'
import * as Session from './session'

export const QuestionCopy = (props) => (
    props.tree.sections.map( (section, sectionOffset) => 
        <div key={sectionOffset}>
            {
                section.subSections.map( (subSection, subSectionOffset) => 
                    <div key={subSectionOffset}>
                        <h5>
                            {section.title}
                        </h5>
                        <h6 className="text-secondary">
                            {subSection.title}
                        </h6>
                        {
                            subSection.stages.map( (stage, stageOffset) =>
                                <StageItem 
                                    key={stageOffset}
                                    stage={stage}
                                    stageOffset={stageOffset}
                                    questions={stage.questions}
                                    scaleItems={Scale.Options}
                                    />
                            )
                        }
                    </div>
                )
            }
        </div>
    )
)


const StageItem = (props) => (
    <div style={ { marginTop: '2em' } }>
        <StageTitle
            text={props.stage.title}
            />
        <QuestionTable 
            stageOffset={props.stageOffset}
            questions={props.stage.questions}
            scaleItems={props.scaleItems}
            />
    </div>
)

const StageTitle = (props) => (
    <div style={ { marginBottom: '1em'} }>
        {props.text}
    </div>
)

const QuestionTable = (props) => (
    <table className="table">
        <tbody>
            {
                props.questions.map( (question, questionOffset) => {
                    return [
                        <QuestionRow 
                            key={`question-${questionOffset}`}
                            number={questionOffset + 1} 
                            question={question}/>
                            ,
                        <ScaleRow 
                            key={`scale-${questionOffset}`}
                            group={`${uniqueID()}`} 
                            scaleItems={props.scaleItems}
                            scaleValue={question.response}
                            />
                    ]
                }) 
            }
        </tbody>
    </table>
)

const uniqueID = () => Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36)

const QuestionRow = (props) => (
    <tr>
        <td colSpan="1000" className="bg-light">
            {props.number}
            &nbsp;
            -
            &nbsp;
            {props.question.title}
        </td>
    </tr>
)


const ScaleRow = (props) => (
    <tr>
        {
            props.scaleItems.map( (item, scaleOffset) => 
                <ScaleItem 
                    key={scaleOffset} 
                    group={props.group} 
                    item={item}
                    checked={item.value === props.scaleValue}
                    />
            )
        }
    </tr>
)

const ScaleItem = (props) => (
    <td className="text-center">
        {props.item.label}
        <br/>
        <RadioBox
            group={props.group}
            value={props.item.value}
            checked={props.checked}
            />
        <div style={ { marginBottom: '1em' } }>
        </div>
    </td>
)

// Disabled radio
const RadioBox = (props) => (
    <input 
        type="radio"
        name={props.group}
        value={props.value}
        checked={props.checked}
        disabled
        />
)


// WEBPACK FOOTER //
// ./src/QuestionCopy.jsx